/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_In_Reason_AdjustmentInputs */

const vi_sl_in_reason_adjustment = /** @type {(inputs: Sl_In_Reason_AdjustmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điều chỉnh`)
};

/**

* @param {Sl_In_Reason_AdjustmentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_in_reason_adjustment = /** @type {((inputs?: Sl_In_Reason_AdjustmentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_In_Reason_AdjustmentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_in_reason_adjustment(inputs)
});